import { getDomainCfg } from "../../core/state";
import { editorUndo } from "../MonacoEditorHelper";
import { previewCode, registerAsset } from "../../features/assets/asset-utils";
import { getKeyForAsset } from "../../features/assets/assetsI18n";

export function AssetLibEntryImage(props: { data : any, tab : any }) {

  const previewImage = () => {
    previewCode(props.data, props.tab);
  }

  const undoPreview = () => {
    editorUndo();
  }

  const insertImageCode = () => {
    previewCode(props.data, props.tab);
    registerAsset(props.data);
  }

  const file = getDomainCfg().viewSettings.features.assetsWithThumbs ? props.data.file.replace('.png', '_thumb.png') : props.data.file;
  const key = getKeyForAsset(props.data.name);

  return (
    <div className='gallery_product col-lg-1 col-md-1 col-sm-1 col-xs-1' onMouseEnter={previewImage} onMouseLeave={undoPreview} onClick={insertImageCode}>
        <img className='img-responsive box-wh' src={file} alt={props.data.name} loading="lazy" />
      <p className='text-center'>{key}</p>
    </div>
    );
}
